import { getStoreBuilder, BareActionContext } from 'vuex-typex';
import { RootState } from './index';
import { TimeSpan } from '@/models/CalendarEntries';
import { Person } from '@/models/Person';

export interface MeetingCalendarState {
    selectedTimeSpan: TimeSpan;
    selectedPerson: Person;
}

const initialState: MeetingCalendarState = {
    selectedTimeSpan: {} as TimeSpan,
    selectedPerson: {} as Person
};

const store = getStoreBuilder<RootState>().module('meeting', initialState);

// private getters
function getStoreSelectedMeetingTimeSpan(state: MeetingCalendarState): TimeSpan {
    return state.selectedTimeSpan;
}
function getStoreSelectedMeetingPerson(state: MeetingCalendarState): Person {
    return state.selectedPerson;
}

// getters
const getSelectedMeetingTimeSpan = store.read(getStoreSelectedMeetingTimeSpan, 'getStoreSelectedMeetingTimeSpan');
const getSelectedMeetingPerson = store.read(getStoreSelectedMeetingPerson, 'getStoreSelectedMeetingPerson');

// mutations:
function mutateSelectedMeetingTimeSpan(state: MeetingCalendarState, payload: TimeSpan | null): Promise<void> {
    return new Promise((resolve, reject) => {
        if (payload === null) {
            state.selectedTimeSpan = {} as TimeSpan;
        } else {
            state.selectedTimeSpan = payload;
        }
        resolve();
    });
}
function mutateSelectedMeetingPerson(state: MeetingCalendarState, payload: Person | undefined): Promise<void> {
    return new Promise((resolve, reject) => {
        if (payload === undefined) {
            state.selectedPerson = {} as Person;
        } else {
            state.selectedPerson = payload;
        }
        resolve();
    });
}

// actions
async function saveSelectedMeetingTimeSpan(
    context: BareActionContext<MeetingCalendarState, RootState>,
    payload: TimeSpan | null
): Promise<void> {
    return await mutateSelectedMeetingTimeSpan(context.state, payload);
}
async function saveSelectedMeetingPerson(
    context: BareActionContext<MeetingCalendarState, RootState>,
    payload: Person | undefined
): Promise<void> {
    return await mutateSelectedMeetingPerson(context.state, payload);
}

// export store
export const MeetingCalendarStore = {
    setSelectedMeetingTimeSpan: store.dispatch(saveSelectedMeetingTimeSpan, 'saveSelectedMeetingTimeSpan'),
    setSelectedMeetingPerson: store.dispatch(saveSelectedMeetingPerson, 'saveSelectedMeetingPerson'),
    get getSelectedMeetingTimeSpan() {
        return getSelectedMeetingTimeSpan();
    },
    get getSelectedMeetingPerson() {
        return getSelectedMeetingPerson();
    }
};
